
import { createAction, props } from '@ngrx/store';

export const loadLanguageData = createAction('[Data Language API] Load Data');
export const loadLanguageDataSuccess = createAction('[Data Language API] Load Data Success', props<any>());
export const loadLanguageDataFailure = createAction('[Data Language API] Load Data Failure', props<any>());
